export default __webpack_public_path__ + "925d8b524e959ef7de84586f9bbce31e.jpg";